import { render, staticRenderFns } from "./TrainingReportsPage.vue?vue&type=template&id=07d3e497&"
import script from "./TrainingReportsPage.vue?vue&type=script&lang=js&"
export * from "./TrainingReportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports